//import "core-js/stable";
import "regenerator-runtime/runtime";
import "@webcomponents/webcomponentsjs/webcomponents-bundle.js";
import Vue from "vue";

import App from "./App.vue";

import "./lib/index";
import "./plugins/gsap";
import "./plugins/vue-carousel";
//import "./plugins/lottie-player";
import "./modules/index";

import router from "./router";
import store from "./store";

import webConfig from "./config.js";
import Notify from "@/assets/plugins/vue-notifikation/notification";
import CathayAxios from "@/assets/plugins/cathay.Axios/cathayAxios";
//import VueMeta from "vue-meta";

Vue.config.productionTip = false;
Vue.prototype.$conf = webConfig;
Vue.prototype.$conf.INIT();
Vue.prototype.$publicPath = process.env.BASE_URL;
Vue.prototype.$conf.SHOW_RTNMESSAGE = false;

Vue.use(CathayAxios, { conf: Vue.prototype.$conf });
Vue.use(Notify);
//Vue.use(VueMeta);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
